import React from 'react';

const ReturnPolicy = () => {
  return (
    <div className="policy-wrapper">
      <div className="policy-container">
        
        <div className="policy-header">
          <div className="header-icon-wrapper">
            <svg className="header-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
          </div>
          <h1 className="policy-title">Return and Refund Policy</h1>
          <p className="policy-date">Last Updated: 2026-03-24</p>
        </div>

        <div className="policy-content">
          <section className="intro-section">
            <p>
              Thank you for shopping at <strong>AlarcTrade</strong>. We want you to be completely satisfied with your purchase. If you are not entirely happy with your order, we're here to help.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              1. Returns Eligibility
            </h2>
            <p>
              You have <strong>10 days</strong> to return an item from the date you received it. To be eligible for a return, your item must meet the following conditions:
            </p>
            <ul className="custom-list">
              <li>The item must be unused and in the same condition that you received it.</li>
              <li>The item must be in the original packaging, with all tags attached.</li>
              <li>You must have the receipt or proof of purchase.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>
              2. Non-Returnable Items
            </h2>
            <p>Certain types of items cannot be returned, including:</p>
            <ul className="custom-list">
              <li>Perishable goods (e.g., food, flowers)</li>
              <li>Custom-made or personalized products</li>
              <li>Intimate or sanitary goods, hazardous materials, or flammable liquids/gases</li>
              <li>Gift cards and downloadable software products</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              3. Refund Process
            </h2>
            <p>
              Once we receive your item, we will inspect it and notify you that we have received your returned item. We will immediately notify you on the status of your refund after inspecting the item.
            </p>
            <p>
              If your return is approved, we will initiate a refund to your credit card (or original method of payment). You will receive the credit within a certain amount of days, depending on your card issuer's policies.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
              4. Exchanges
            </h2>
            <p>
              We only replace items if they are defective or damaged upon arrival. If you need to exchange it for the same item, send us an email at{' '}
              <a href="mailto:contact@alarctrade.com" className="text-link">contact@alarctrade.com</a>.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              5. Shipping Costs for Returns
            </h2>
            
            <div className="policy-alert">
              <div className="alert-content">
                <div className="alert-icon-wrapper">
                  <svg className="alert-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="alert-text">
                  <p>
                    <strong>Note:</strong> You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable.
                  </p>
                </div>
              </div>
            </div>

            <p>
              If you receive a refund, the cost of return shipping will be deducted from your refund (unless the return is due to an error on our part, such as receiving a defective item).
            </p>
          </section>

          <section className="policy-section">
            <div className="contact-card">
              <h2 className="contact-title">Need further assistance?</h2>
              <p className="contact-subtitle">If you have any questions on how to return your item to us, please contact our support team:</p>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="label">Email:</span>
                  <a href="mailto:contact@alarctrade.com" className="text-link font-medium">contact@alarctrade.com</a>
                </div>
                <div className="contact-item">
                  <span className="label">Address:</span>
                  <span className="address-text">C/O KAWOSHE ACHUMI, DOPN
CHEKIYE, BLOCK 5. AGASA 4TH MILE, DIMAPUR
797115</span>
                </div>
              </div>
            </div>
          </section>
        </div>

      </div>
    </div>
  );
};

export default ReturnPolicy;